import styled from "styled-components";

export const LayoutContentContainer = styled.div`
  padding-top: 1rem;
`;
